import { z } from 'zod'

import { ResponsibleMedicalRecord } from './ResponsibleMedicalRecord'

export const ResponsibleMedicalRecordReview = z.object({
  sendResponsible: ResponsibleMedicalRecord,
  registerPatient: ResponsibleMedicalRecord
})
export type ResponsibleMedicalRecordReview = z.infer<
  typeof ResponsibleMedicalRecordReview
>
